<!--Title Section-->
<app-title-jumbo title="Investment Solution" comment="Improve your strategy thanks to a completeness portfolio of factor based products"></app-title-jumbo>

<div class="my-container">

  <!--Universe Section-->
  <section>
    <div class="container">
      <div class="offset-1 col-10">
        <mat-accordion *ngIf="currentCluster">
          <mat-expansion-panel [expanded]="false"
                              (opened)="panelOpenState = true"
                              (closed)="panelOpenState = false">
            <mat-expansion-panel-header>
              <mat-panel-title>
                {{ currentCluster.name }}
              </mat-panel-title>
              <mat-panel-description *ngIf="!panelOpenState">
                {{ currentCluster.investment_zone.name }} - {{ currentCluster.currency.name }} - {{ currentCluster.market_positions.name }}
              </mat-panel-description>
            </mat-expansion-panel-header>

            <div class="row">
              <div class="col-6" style="line-height: 30px">
                <span style="color: grey">Portfolio</span>
                <span *ngIf="currentOriginal" class="float-right">{{ currentOriginal.name }}</span>
                <span *ngIf="!currentOriginal" class="float-right">Undefined</span>
              </div>
              <div class="col-6" style="line-height: 30px">
                <span style="color: grey">Target Strategy</span>
                <span *ngIf="currentStrategy" class="float-right">{{ currentStrategy.name }}</span>
              </div>
              <div class="col-6" style="line-height: 30px">
                <div class="w-100" style="border-top:1px dotted grey"></div>
                <span style="color: grey">Inception date</span>
                <span class="float-right">{{ currentCluster.inception_date | date:'d MMM y' }}</span>
              </div>
              <div class="col-6" style="line-height: 30px">
                <div class="w-100" style="border-top:1px dotted grey"></div>
                <span style="color: grey">As of</span>
                <span class="float-right">{{ currentCluster.last_date | date:'d MMM y' }}</span>
              </div>
              <div class="col-6" style="line-height: 30px">
                <span style="color: grey">Benchmark</span>
                <span class="float-right">{{ currentCluster.benchmark_name }}</span>
              </div>
              <div class="col-6" style="line-height: 30px">
                <span style="color: grey">Market positions</span>
                <span class="float-right">{{ currentCluster.market_positions.name }}</span>
              </div>
              <div class="col-6" style="line-height: 30px">
                <span style="color: grey">Investment zone</span>
                <span class="float-right">{{ currentCluster.investment_zone.name }}</span>
                <div class="w-100" style="border-bottom:1px dotted grey"></div>
              </div>
              <div class="col-6" style="line-height: 30px">
                <span style="color: grey">Currency</span>
                <span class="float-right">{{ currentCluster.currency.name }}</span>
                <div class="w-100" style="border-bottom:1px dotted grey"></div>
              </div>
            </div>
          </mat-expansion-panel>
        </mat-accordion>

        <!-- Card deck -->
        <div class="card-deck mt-3">

          <!-- Card Improve -->
          <div class="card mb-4">

            <!--Card image-->
            <div *ngIf="selectBlock==''" class="view overlay">
              <img class="card-img-top" src="assets/img/027.png"
                  alt="Card image cap">
            </div>

            <!--Card content-->
            <div class="card-body">

              <!--Title-->
              <h4 class="card-title" [ngStyle]="{'color': selectBlock=='improve'? 'rgb(118,168,255)' : 'grey'}"><i class="fas fa-cubes fa-lg"></i>&nbsp;&nbsp;&nbsp; Constraints</h4>
              <!--Text-->
              <p class="card-text">You may define the level of trading budget and additional cash, constraints on weights and add funds filter.</p>
              <!-- Provides extra visual weight and identifies the primary action in a set of buttons -->
              <app-button (click)="selectBlock='improve'">Constraints</app-button>

            </div>

            <!--Card footer-->
            <div *ngIf="selectBlock==''" class="card-footer text-right">
              <small *ngIf="currentCluster" class="text-muted">{{ currentCluster.inception_date | date:'d MMM y' }} — {{ currentCluster.last_date | date:'d MMM y' }}</small>
            </div>

          </div>
          <!-- Card Improve -->

          <!-- Card Optimize -->
          <div class="card mb-4">

            <!--Card image-->
            <div *ngIf="selectBlock==''" class="view overlay">
              <img class="card-img-top" src="assets/img/028.png"
                  alt="Card image cap">
            </div>

            <!--Card content-->
            <div class="card-body">

              <!--Title-->
              <h4 class="card-title" [ngStyle]="{'color': selectBlock=='computation'? 'rgb(118,168,255)' : 'grey'}"><i class="fas fa-magic fa-lg"></i>&nbsp;&nbsp;&nbsp; Optimization</h4>
              <!--Text-->
              <p class="card-text">Run the optimization and adjust your constraints if necessary to achieve the best possible solution for your investment.</p>
              <!-- Provides extra visual weight and identifies the primary action in a set of buttons -->
              <app-button [disabled]="!(investableParameters.completeness_products.length>1)" (click)="selectBlock='computation'">Optimization</app-button>

            </div>

            <!--Card footer-->
            <div *ngIf="selectBlock==''" class="card-footer text-right">
              <small *ngIf="currentCluster" class="text-muted">{{ currentCluster.inception_date | date:'d MMM y' }} — {{ currentCluster.last_date | date:'d MMM y' }}</small>
            </div>

          </div>
          <!-- Card Optimize -->

          <!-- Card Implement -->
          <div class="card mb-4">

            <!--Card image-->
            <div *ngIf="selectBlock==''" class="view overlay">
              <img class="card-img-top" src="assets/img/029.png"
                  alt="Card image cap">
            </div>

            <!--Card content-->
            <div class="card-body">

              <!--Title-->
              <h4 class="card-title" [ngStyle]="{'color': selectBlock=='implement'? 'rgb(118,168,255)' : 'grey'}"><i class="fas fa-arrow-alt-circle-down fa-lg"></i>&nbsp;&nbsp;&nbsp; Implement</h4>
              <!--Text-->
              <p class="card-text">Having defined the quarterly rebalancing, you may implement the Investable Portfolio and get access to the Analytics.</p>
              <!-- Provides extra visual weight and identifies the primary action in a set of buttons -->
              <app-button [disabled]="!(investableParameters.completeness_products.length>1) || !optimizeOk" (click)="selectBlock='implement'">Implement</app-button>

            </div>

            <!--Card footer-->
            <div *ngIf="selectBlock==''" class="card-footer text-right">
              <small *ngIf="currentCluster" class="text-muted">{{ currentCluster.inception_date | date:'d MMM y' }} — {{ currentCluster.last_date | date:'d MMM y' }}</small>
            </div>

          </div>
          <!-- Card Implement -->

        </div>
        <!-- Card deck -->
      </div>
    </div>

    <app-investable-constraints [ngClass]="{'d-none':selectBlock!='improve'}" [(optimizeOk)]="optimizeOk" [(improveOk)]="improveOk" (changeBlock)="onChangeBlock($event)"></app-investable-constraints>
    <app-investable-optimization *ngIf="selectBlock=='computation'" [(isComputing)]="isComputing" [(optimizeOk)]="optimizeOk" [(improveOk)]="improveOk" (changeBlock)="onChangeBlock($event)"></app-investable-optimization>
    <app-investable-implement *ngIf="selectBlock=='implement'" [(isComputing)]="isComputing"></app-investable-implement>

  </section>
  <!--Universe Section-->
